import React from 'react'
import {Icon} from '@chakra-ui/react'

const BestSellerIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M5.81 17.99C4.91 17.99 4.13 17.38 3.89 16.52L1.05 6.28001C0.95 5.89001 1 5.49001 1.2 5.14001C1.4 4.79001 1.72 4.54001 2.11 4.44001C2.58 4.31001 3.08 4.42001 3.45 4.72001L7.75 8.40001L10.68 2.79001C10.68 2.79001 10.68 2.78001 10.68 2.77001C10.87 2.42001 11.19 2.16001 11.58 2.05001C11.97 1.94001 12.37 1.98001 12.72 2.18001C12.97 2.31001 13.17 2.52001 13.31 2.77001L16.27 8.39001L20.53 4.73001C21.19 4.19001 22.14 4.29001 22.66 4.93001C22.96 5.30001 23.07 5.81001 22.94 6.27001L20.11 16.52C19.88 17.38 19.09 17.98 18.2 17.99H5.81ZM3.42 7.33001L5.82 15.99H18.19L20.58 7.32001L17.56 9.91001C17.45 10 17.34 10.07 17.23 10.13C16.25 10.66 15.04 10.3 14.51 9.33001L12 4.56001L9.49 9.32001C9.42 9.45001 9.35 9.55001 9.26 9.65001C8.92 10.06 8.44 10.31 7.91 10.36C7.38 10.41 6.86 10.25 6.45 9.91001L3.41 7.31001L3.42 7.33001Z"
                fill="currentColor"
            />
            <path
                d="M19 21.99H5C4.45 21.99 4 21.54 4 20.99C4 20.44 4.45 19.99 5 19.99H19C19.55 19.99 20 20.44 20 20.99C20 21.54 19.55 21.99 19 21.99Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default BestSellerIcon
